module.exports = __webpack_public_path__ + "static/media/demographic_active.a43fd905.svg";